import { useState } from "react";
import { getSemaforoExcel } from "../services/semaforoExcel";

export const useSemaforoExcel = () => {
  const [loading, setLoading] = useState(false);

  const downloadExcel = async (filters) => {
    try {
      setLoading(true);

      console.log(filters);

      const blob = await getSemaforoExcel(filters);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "semaforo.xlsx";
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    downloadExcel,
    loading,
  };
};
